import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SizeGuides, ShoeSizeGuideType } from './constants';

const WidthHead = () => (
  <thead>
    <tr>
      <th scope="col" rowSpan={2}>
        <FormattedMessage id="sizeGuide.header.length" />
      </th>
      <th scope="colgroup" colSpan={3}>
        <FormattedMessage id="sizeGuide.header.width" />
      </th>
      <th scope="col" rowSpan={2}>
        <FormattedMessage id="sizeGuide.header.eu" />
      </th>
      <th scope="col" rowSpan={2}>
        <FormattedMessage id="sizeGuide.header.uk" />
      </th>
      <th scope="col" rowSpan={2}>
        <FormattedMessage id="sizeGuide.header.us" />
      </th>
    </tr>
    <tr>
      <th scope="col" className="size-guide-table__subhead">
        <FormattedMessage id="sizeGuide.header.narrow" />
      </th>
      <th scope="col" className="size-guide-table__subhead">
        <FormattedMessage id="sizeGuide.header.average" />
      </th>
      <th scope="col" className="size-guide-table__subhead">
        <FormattedMessage id="sizeGuide.header.wide" />
      </th>
    </tr>
  </thead>
);

const SimpleHead = () => (
  <thead>
    <tr>
      <th scope="col">
        <FormattedMessage id="sizeGuide.header.kidsLength" />
      </th>
      <th scope="col">
        <FormattedMessage id="sizeGuide.header.eu" />
      </th>
      <th scope="col">
        <FormattedMessage id="sizeGuide.header.uk" />
      </th>
      <th scope="col">
        <FormattedMessage id="sizeGuide.header.us" />
      </th>
    </tr>
  </thead>
);

const ShoeSizeGuide = ({ type }) => {
  const guide = SizeGuides[type];

  if (!guide) {
    return null;
  }

  const captionId = `size-guide-caption-${type}`;

  return (
    <div className="size-guide-table-wrapper">
      <table className={`size-guide-table ${type}`}>
        <caption id={captionId} className="size-guide-table__caption">
          <FormattedMessage id={guide.caption} />
        </caption>
        {guide.variant === 'width' ? <WidthHead /> : <SimpleHead />}
        <tbody>
          {guide.rows.map(row => (
            <tr key={row[0]}>
              {guide.columns.map((column, index) => (
                <td key={column}>{row[index]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ShoeSizeGuide.propTypes = {
  type: PropTypes.oneOf(Object.values(ShoeSizeGuideType)).isRequired,
};

export default ShoeSizeGuide;
